import {createApp} from 'vue'
import SourceGroupCard from './SourceGroupCard'

const el = '.kb-component--source-group-card'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((SourceGroupCardDOM)=>{

            const props = {
                name: SourceGroupCardDOM.dataset.name,
                title: SourceGroupCardDOM.dataset.title,
                text: SourceGroupCardDOM.dataset.text,
                linkUrl: SourceGroupCardDOM.dataset.linkUrl,
                linkText: SourceGroupCardDOM.dataset.linkText,
            }
            const component = createApp(SourceGroupCard, props).use(Store)
            component.mount(SourceGroupCardDOM)
        })
    }
}